import { render, staticRenderFns } from "./TranslateReportList.vue?vue&type=template&id=73d7c958&"
import script from "./TranslateReportList.vue?vue&type=script&lang=js&"
export * from "./TranslateReportList.vue?vue&type=script&lang=js&"
import style0 from "./TranslateReportList.vue?vue&type=style&index=0&id=73d7c958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports